import React from "react"
import { useSelector } from "react-redux"

import { QidDatapoint } from "server/models"
import {
    StoreType,
    QidResultType,
} from "client/store"
import { TableColumn } from "client/components"

import FormatScientific from "client/pages/sil/format/scientific"

const Columns = () => {
    const lang = useSelector((state: StoreType) => state.system.lang)

    const columns: TableColumn[] = [
        {
            field: "failureMode",
            cellMinWidth: "250px",
            formatter: (data: QidDatapoint | QidResultType) => {
                const datapoint = data as QidDatapoint
                if (datapoint.id && datapoint.failureModeId && datapoint.failureMode) {
                    return datapoint.failureMode.name
                }
                if (datapoint.id && !datapoint.failureModeId) {
                    return lang.failureMode
                }
                if (!datapoint.id) { // QidResultType
                    return <b>{lang.total}</b>
                }
                return null
            },
        },
        {
            field: "sd",
            header: "SD",
            cellMinWidth: "100px",
            formatter: (data: QidResultType) => <FormatScientific data={data.sd} tableView />,
        },
        {
            field: "su",
            header: "SU",
            cellMinWidth: "100px",
            formatter: (data: QidResultType) => <FormatScientific data={data.su} tableView />,
        },
        {
            field: "dd",
            header: "DD",
            cellMinWidth: "100px",
            formatter: (data: QidResultType) => <FormatScientific data={data.dd} tableView />,
        },
        {
            field: "du",
            header: "DU",
            cellMinWidth: "100px",
            formatter: (data: QidResultType) => <FormatScientific data={data.du} tableView />,
        },
    ]

    return columns
}
export default Columns
